import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css"; // custom styles
import { motion, AnimatePresence } from "framer-motion";

export default function Quizz() {
  const [current, setCurrent] = useState(1);
  const [direction, setDirection] = useState("next");

  // Questions with options
  const questions = [
    {
      text: "Which of the following is a popular programming language for developing multimedia webpages?",
      options: ["A. COBOL", "B. JavaScript", "C. Python", "D. Ruby"],
    },
    {
      text: "Which company developed the Java language?",
      options: ["A. Sun Microsystems", "B. Microsoft", "C. Oracle", "D. IBM"],
    },
    {
      text: "React is maintained by which company?",
      options: ["A. Google", "B. Microsoft", "C. Facebook (Meta)", "D. Amazon"],
    },
  ];

  // Variants for the main question container
  const variants = {
    enter: (dir) => ({
      x: dir === "next" ? 50 : -50,
      opacity: 0,
    }),
    center: { x: 0, opacity: 1 },
    exit: (dir) => ({
      x: dir === "next" ? -50 : 50,
      opacity: 0,
    }),
  };

  // Variants for staggered options
  const optionContainer = {
    show: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const optionItem = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  const handleNext = () => {
    if (current < questions.length) {
      setDirection("next");
      setCurrent((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (current > 1) {
      setDirection("prev");
      setCurrent((prev) => prev - 1);
    }
  };

  return (
    <div className="quiz-wrapper">
      <div className="quiz-body">
        {/* Header */}
        <div className="quiz-header d-flex justify-content-between align-items-center">
          <motion.img
            src="/assets/images/quiz-doctor.png"
            className="logoImg mb-4"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          />
        </div>

        {/* Card Wrapper */}
        <motion.div
          className="quiz-card bg-white"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
        >
          {/* Animate Questions */}
          <AnimatePresence mode="wait" custom={direction}>
            <motion.div
              key={current}
              custom={direction}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ duration: 0.5 }}
            >
              <div className="row align-items-start">
                {/* Left side: Question + Options */}
                <div className="col-lg-7 col-12">
                  <p className="fw-semibold mb-2">
                    Question {current} of {questions.length}
                  </p>
                  <h6 className="fw-bold question-text">
                    {questions[current - 1].text}
                  </h6>

                  {/* Options with staggered animation */}
                  <motion.div
                    className="row row-cols-2 g-3 my-3"
                    variants={optionContainer}
                    initial="hidden"
                    animate="show"
                  >
                    {questions[current - 1].options.map((opt, i) => (
                      <motion.div
                        className="col"
                        key={i}
                        variants={optionItem}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                      >
                        <button className="btn option-btn w-100 text-start">
                          {opt}
                        </button>
                      </motion.div>
                    ))}
                  </motion.div>
                </div>

                {/* Right side: Score / Submit */}
                <div className="col-lg-5 col-12 text-end d-flex align-items-center justify-content-end">
                  <motion.button
                    className="btn btn-submit"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Submit
                  </motion.button>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Navigation Buttons */}
          <div className="d-flex justify-content-between align-items-center mt-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              <motion.button
                className="btn btn-nav me-2"
                disabled={current === 1}
                onClick={handlePrev}
                whileHover={{ scale: current !== 1 ? 1.05 : 1 }}
                whileTap={{ scale: current !== 1 ? 0.95 : 1 }}
              >
                Prev
              </motion.button>
              <motion.button
                className="btn btn-nav ms-2"
                disabled={current === questions.length}
                onClick={handleNext}
                whileHover={{
                  scale: current !== questions.length ? 1.05 : 1,
                }}
                whileTap={{
                  scale: current !== questions.length ? 0.95 : 1,
                }}
              >
                Next
              </motion.button>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
